'use client';


import { Skeleton } from '@/components/ui/skeleton';

export default function Loading() {
  return (
    <div className="py-6 md:py-10">
      <div className="max-w-5xl mx-auto">
        <Skeleton className="h-10 w-48 mb-6" />
        <div className="flex space-x-4 mb-6">
          <Skeleton className="h-8 w-32 rounded-full" />
          <Skeleton className="h-8 w-32 rounded-full" />
        </div>
        <div className="space-y-6">
          {Array.from({ length: 3 }).map((_, idx) => (
            <Skeleton key={idx} className="h-48 w-full" />
          ))}
        </div>
      </div>
    </div>
  );
}